import { render } from "./PaymentCancelPage.vue?vue&type=template&id=629f0f90&scoped=true&ts=true"
import script from "./PaymentCancelPage.vue?vue&type=script&lang=ts"
export * from "./PaymentCancelPage.vue?vue&type=script&lang=ts"

import "./PaymentCancelPage.vue?vue&type=style&index=0&id=629f0f90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629f0f90"]])

export default __exports__